import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetOpenOrderList } from "@/api";
import type { GetOpenOrderListResponse } from "@/api/types";

/**
 * 获取未平仓订单列表（滚动分页）
 * 对应接口：`/game/cex/GetOpenOrderList`
 *
 * 约定：
 * - 每次固定拉取 100 条
 * - 使用 `useInfiniteQuery` 做无限滚动分页
 */
export function useGetOpenOrderList() {
  const pageSize = 100;

  return useInfiniteQuery({
    queryKey: ["openOrderList", pageSize],
    initialPageParam: 1,
    queryFn: async ({ pageParam }): Promise<GetOpenOrderListResponse> => {
      const page =
        typeof pageParam === "number" && pageParam > 0 ? pageParam : 1;
      const res = await ApiGetOpenOrderList({ page, pageSize });
      console.log("useGetOpenOrderList", res.data);
      return res.data;
    },
    getNextPageParam: (lastPage, allPages) => {
      const fetchedCount = allPages.reduce(
        (acc, page) => acc + (page.items?.length ?? 0),
        0
      );
      if (fetchedCount >= (lastPage.total ?? 0)) return undefined;
      if ((lastPage.items?.length ?? 0) === 0) return undefined;
      return allPages.length + 1;
    },
  });
}
